// assets/js/utils/initLenis.js
import Lenis from "@studio-freight/lenis";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

let _lenis;
let _tickerCallback;

export function initLenis(options = {}) {
  if (_lenis) return _lenis;

  const isMobile = window.matchMedia("(max-width: 768px)").matches;

  // ==============================
  // 🚫 MÓVIL: SIN LENIS, SCROLL NATIVO
  // ==============================
  if (isMobile) {
    console.log("🚀 [Lenis] Modo móvil: scroll nativo, sin Lenis");

    // ✅ CORRECCIÓN: Eliminar cualquier scrollerProxy previo
    // Pasar null al segundo argumento "resetea" al comportamiento por defecto
    ScrollTrigger.clearScrollMemory();
    ScrollTrigger.defaults({ scroller: window });
    ScrollTrigger.refresh(true);

    return null;
  }

  // resto del código para desktop igual
  const lenis = new Lenis({
    duration: 1.2,
    lerp: 0.1,
    smoothWheel: true,
    smoothTouch: false,
    ...options,
  });

  lenis.on("scroll", ScrollTrigger.update);

  _tickerCallback = (time) => {
    lenis.raf(time * 1000);
  };
  gsap.ticker.add(_tickerCallback);
  gsap.ticker.lagSmoothing(0);

  ScrollTrigger.scrollerProxy(document.body, {
    scrollTop(value) {
      if (arguments.length) {
        lenis.scrollTo(value, { immediate: true });
      }
      return lenis.scroll;
    },
    getBoundingClientRect() {
      return {
        top: 0,
        left: 0,
        width: window.innerWidth,
        height: window.innerHeight,
      };
    },
    pinType: "transform",
  });

  ScrollTrigger.addEventListener("refresh", () => lenis.resize());
  ScrollTrigger.refresh();

  _lenis = lenis;
  return lenis;
}

export function destroyLenis() {
  if (!_lenis) return;

  if (_tickerCallback) {
    gsap.ticker.remove(_tickerCallback);
    _tickerCallback = null;
  }

  _lenis.destroy();
  _lenis = undefined;

  // Resetear ScrollTrigger al comportamiento nativo
  ScrollTrigger.clearScrollMemory();
  ScrollTrigger.defaults({ scroller: window });
  ScrollTrigger.refresh(true);
}
